import {
    convertParsedResumetoUserPartial,
    convertUserResponseToUser,
    convertUserToUserResponse
} from './convert/user';
import { get, post, put } from './http';

import type { CandidateSearch } from '../types/job';
import type { ResumeResponse, User, UserResponse } from '../types/user';

export const createCandidate = (email: string, userID: string) =>
    post('/api/user/candidate', { email, user_id: userID }).then(
        (response: UserResponse) => convertUserResponseToUser(response)
    );

export const createBusiness = (email: string, userID: string) =>
    post('/api/user/business', { email, user_id: userID }).then(
        (response: UserResponse) => convertUserResponseToUser(response)
    );

export const updateUser = (userDict: User) => {
    const userResponse = convertUserToUserResponse(userDict);
    return put('/api/user', userResponse).then((response: UserResponse) =>
        convertUserResponseToUser(response)
    );
};

export const getUser = (userID: string) =>
    get(`/api/user/${userID}`).then((response: UserResponse) =>
        convertUserResponseToUser(response)
    );

export const getUserByID = (userID: number): Promise<User> =>
    get(`/api/user/id/${userID}`).then((response: UserResponse) =>
        convertUserResponseToUser(response)
    );

export const getEligibleUserCount = (searchDict: CandidateSearch) =>
    post('/api/user/eligible', searchDict).then(
        (response: { count: number }) => response?.count || 0
    );

export const setUserOnline = (userID: number) =>
    put('/api/user/online', { id: userID });

export const setUserOffline = (userID: number) =>
    put('/api/user/offline', { id: userID });

export const getUserWithInterviewFeedback = (
    userID: number,
    selectedUserID: number
) => get(`/api/user/feedback/${userID}/${selectedUserID}`);

export const parseResume = (userID: string) =>
    post('/api/user/parseresume', { user_id: userID });

export const getParsedResumeResult = (parseID: string) =>
    get(`/api/user/parseresume/${parseID}`).then(
        (response: {
            status: 'succeeded' | 'processing' | 'failed';
            data: ResumeResponse;
        }) =>
            response.status === 'succeeded'
                ? {
                      status: response.status,
                      data: convertParsedResumetoUserPartial(response.data)
                  }
                : response
    );
